import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-money-bag-02',
  standalone: true,
  templateUrl: '../../assets/money-bag-02.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamMoneyBag02Icon {}
